import { Component } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * Scroll window to top when navigating to a new location. Must be wrapped with
 * a Router (BrowserRouter) component.
 *
 * @example
 * <BrowserRouter>
 *   <ScrollTop>
 *     <Route path="/page1" />
 *     <Route path="/page2" />
 *   </ScrollTop>
 * </BrowserRouter>
 */
class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
